<div id="transmitContainer">
    <section style="display: none;" >
            <form name="new_user_gesture_form" data-form-id="new_user_gesture">
            <h1 id="biometricHeader" [innerHTML]="pageData?.copy$$signon_biometric_header_ugs?.TEXT"></h1>
            <span class='separator separator-rule separator-large' aria-hidden='true'></span>
            <section data-form-id="new_gesture_cancel">
              <div class='button-box reverse-medium-min'>
                 <button class='secondary-large form-submit' id='tmpCancelButton'  [innerHTML]="pageData?.copy$$signon_biometric_btn_cancel?.TEXT"></button>

                </div>
            </section>
            <section data-form-id='new_gesture_confirm' >
                <div class='button-box reverse-medium-min'>
                   <button   class='primary-large form-submit'  id='tmpContinueButton'type='submit' [innerHTML]="pageData?.copy$$signon_biometric_btn_continue?.TEXT" > </button>
                 </div>
              </section>
            </form>

      </section>

</div>
<ng-container *ngIf="notifications">
    <notification *ngFor="let notification of notifications" [ngClass]="{'success':notification.alertType === 'confirmation','error':notification.alertType === 'urgent','warning':notification.alertType === 'account' || notification.alertType === 'status'}" [dismissable]="false"
      name="notification">
      <div [innerHTML]="notification.alertMSG"></div>
    </notification>
  </ng-container >

  <!-- Info Warning messages on signon header-->
  <ng-container *ngIf = "infoOutageWarningMessage()">
      <notification *ngFor="let notification of urgentNotification"  class="warning">
          <div [innerHTML]="notification"></div>
      </notification>
  </ng-container>

  <ng-container>
    <section *ngIf="isBiometricEligible && moduleLoaded" data-component="sign-on-form" data-module="biometric_sign_on" data-view="index"
        class="row w-100 m-0">
        <div class="col-md-4 col-lg-3 sign-on-wrapper">
            <div class="row signon-form-container" #signonFormContainer>
                <div class="col-md-12">
                    <!-- If there is a login-related error, display that error above the form -->
                    <div *ngIf="error">
                        <notification *ngIf="error" class="error" [dismissable]="false" name="error">
                            <div [innerHTML]="error"></div>
                        </notification>
                    </div>
                    <!-- <h1 class="sign-on-heading" [innerHTML]="pageData?.copy$$header_sign_on?.TEXT"></h1> -->
                    <form name="form" [formGroup]="biometricLoginForm" (ngSubmit)="proceedToBiometric($event)"
                        data-form-id="biometric_sign_on" class="form-signin">

                        <div class="row register-card-container border-top">
                            <div class="col-md-12">
                                <div class=" text-center">
                                    <div class="mt-3 ml-auto mr-auto signon-message ">
                                        <img src="../../../RSauth/assets/images/biometric_icon.svg" class="cross-btn "
                                            [alt]="pageData?.copy$$biometric_image_description?.TEXT" />
                                    </div>

                                    <h1 [innerHTML]="pageData?.copy$$signon_biometric_header?.TEXT"
                                        class="text-left biometric-card-heading "></h1>


                                    <div class="text-left">
                                        <div class="masked-input-view biometric-mask-view" role="presentation"
                                            data-aria-hidden="true" aria-hidden="true"></div>
                                        <label for="userId"
                                            [innerHTML]="pageData?.multi_form_field$$formfield_user_id?.FORM_FIELD_LABEL"></label>
                                        <input id="userId" formControlName="userId" autocomplete="off" type="text" required
                                            class="ui-text-input default-width" placeholder="User ID" maxlength="50"
                                            name="userId" userIdInputMask disabled>
                                    </div>



                                    <br />
                                    <div class="text-left mt-1 signonLinks ">
                                        <a (click)="handleNotYou($event)" [attr.href]="retrieveUrl"
                                            [innerHTML]="pageData?.copy$$signon_form_biometric_not_you_link?.TEXT"
                                            class="not-sc-link"></a>
                                    </div>


                                    <br />
                                    <button buttonSpinner class="primary" role="button" type="submit"
                                        [fDetail]="biometricLoginForm" [disabled]="biometricSubmitButtonDisabled"
                                        [innerHTML]="biometricButtonText"
                                        [attr.aria-label]="biometricButtonADAText"></button>
                                    <div class="mt-3 ">
                                        <a [attr.href]="retrieveUrl" (click)="backToPasswordLogin($event)"
                                            [innerHTML]="pageData?.copy$$sign_on_with_password?.TEXT"
                                            class="not-sc-link"></a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>


        </div>
        <div class="col-md-8 col-lg-9">
            <div class="primaryBannerWrapper">
                <primary-banner *ngIf="!adBlockerEnabled"></primary-banner>
                <flex-seo *ngIf="adBlockerEnabled && !isPrimaryContentDiffFromFlexSeo" [pageData]='pageData'
                    [primaryMode]="true" [newCMSContent]="false"></flex-seo>
                <flex-seo *ngIf="adBlockerEnabled && isPrimaryContentDiffFromFlexSeo" [pageData]='pageData'
                    [primaryMode]="true" [newCMSContent]="true"></flex-seo>
            </div>

            <div class="secondaryBannerWrapper" *ngIf="!adBlockerEnabled">
                <secondary-banner></secondary-banner>
            </div>
        </div>
    </section>

    <section *ngIf="!isBiometricEligible && moduleLoaded && showGuestPaySection && !isSingleSignon" data-component="sign-on-form" data-module="guestpay_sign_on"
        data-view="index" class="row w-100 m-0 guestpay">
        <div class="col-md-4 col-lg-3 sign-on-wrapper">
            <div class="row guestpay-form-container">
                <div class="col-md-12">
                    <h1 class="guestpay-heading" [innerHTML]="pageData?.copy$$header_one_time_payment?.TEXT"></h1>
                    <p class="guestpay-subtitle" [innerHTML]="pageData?.copy$$subtext_one_time_payment?.TEXT"></p>
                    <button class="primary" (click)="makeAPaymentGuestpay()" role="button"
                        [innerHTML]="pageData?.copy$$btn_make_a_payment?.TEXT"></button>
                </div>
            </div>
        </div>
    </section>
    <section *ngIf="!isBiometricEligible && moduleLoaded" data-component="sign-on-form" data-module="sign_on" data-view="index" class="row w-100 m-0">
          <div class="col-md-4 col-lg-3 sign-on-wrapper">
              <div class="row signon-form-container" #signonFormContainer>
                  <div class="col-md-12">
                      <!-- If there is a login-related error, display that error above the form -->
                      <div *ngIf="error">
                          <notification *ngIf="error" class="error" [dismissable]="false"
                          name="error">
                          <div [innerHTML]="error"></div>
                          </notification>
                      </div>
                      <h1 *ngIf="!isSingleSignon" class="sign-on-heading" [innerHTML]="pageData?.copy$$header_sign_on?.TEXT"></h1>
                        <h1 *ngIf="isSingleSignon && isFirstTimeUser" class="sign-on-heading" [innerHTML]="pageData?.copy$$sso_header_first_time_user?.TEXT"></h1>
                        <h1 *ngIf="isSingleSignon && !isFirstTimeUser" class="sign-on-heading" [innerHTML]="pageData?.copy$$sso_header_returning_user?.TEXT"></h1>
                      <p *ngIf="isSingleSignon && isFirstTimeUser" class="sso_info_access" [innerHTML]="pageData?.copy$$info_single_sign_on_now_you_can_access_your_account?.TEXT"></p>
                      <p *ngIf="isSingleSignon && !isFirstTimeUser" class="sso_info_access" [innerHTML]="pageData?.copy$$info_sso_access_your_account_returning_user?.TEXT"></p>

                      <form *ngIf="loginForm" name="form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" data-form-id="sign_on" class="form-signin">
                          <div class="form-group">
                              <div class="masked-input-view" role="presentation" data-aria-hidden="true" aria-hidden="true" ></div>
                              <input id="userId" formControlName="userId" autocomplete="off" type="text" required class="ui-text-input default-width" placeholder="User ID" maxlength="50" name="userId" userIdInputMask>
                              <label for="userId" [innerHTML]="pageData?.multi_form_field$$formfield_user_id?.FORM_FIELD_LABEL"></label>
                              <div class="field">
                                  <div *ngIf="userId.invalid && userId.touched" class="field-alert">
                                      <div class="field-error" *ngIf="userId.errors.message">
                                          <div class="icon"></div>
                                          <div class="message" [innerHTML]="userId.errors.message.value"></div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div class="checkbox" [attr.data-checked]="loginForm.value.rememberMe ? true : false">
                              <div class="">
                                  <input id="rememberMe" type="checkbox" formControlName="rememberMe" class="text_input default-width checkbox">
                                  <label class="rememberMe" for="rememberMe" [innerHTML]="pageData?.multi_form_field$$formfield_remember_user_id?.FORM_FIELD_LABEL"></label>
                              </div>
                          </div>

                          <div class="form-group mt-4" (capsLock)="capsOn=$event">
                              <input id="password" formControlName="password" autocomplete="off" type="password" inputMask="password" required class="ui-text-input default-width" placeholder="Password" maxlength="64">
                              <span class="caps-lock-icon" *ngIf="capsOn" aria-label="Caps lock is on."></span>
                              <label for="password" [innerHTML]="pageData?.multi_form_field$$formfield_password?.FORM_FIELD_LABEL"></label>
                              <div class="field">
                                  <div *ngIf="password.invalid && password.touched" class="field-alert">
                                      <div class="field-error" *ngIf="password.errors.message">
                                          <div class="icon"></div>
                                          <div class="message" [innerHTML]="password.errors.message.value"></div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div *ngIf="(siteIdCan=='CACN_HOMEDEPOT')" class="checkbox" [attr.data-checked]="loginForm.value.canadaCookieConsent ? true : false">
                            <div class="">
                                <input id="canadaCookieConsent" type="checkbox" formControlName="canadaCookieConsent" required class="text_input default-width checkbox">
                                <label class="canadaCookieConsent" for="canadaCookieConsent" [innerHTML]="pageData?.multi_form_field$$formfield_checkbox_accept_cookies?.FORM_FIELD_LABEL"></label>
                                <div class="form-group">
                                    <div class="field">
                                        <div *ngIf="canadaCookieConsent.invalid && canadaCookieConsent.touched" class="field-alert">
                                            <div class="field-error" *ngIf="canadaCookieConsent.errors.message">
                                                <div class="icon"></div>
                                                <div class="message" [innerHTML]="canadaCookieConsent.errors.message.value"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          </div>
                          <p *ngIf="isSingleSignon" class="sso_info_contine" [innerHTML]="pageData?.copy$$info_sso_you_have_chosen_to_continue?.TEXT"></p>
                          <button buttonSpinner [hasValidation]="true" [disabled]="submitButtonDisabled" [fDetail]="loginForm" class="primary" type="submit" [innerHTML]="pageData?.copy$$btn_sign_on?.TEXT"></button>
                        <div class="mt-3 signonLinks text-center" *ngIf="!isSingleFuipFlow">
                          <a [attr.href]="retrieveUrl" (click)="forgotUserId($event)" class="not-sc-link" [innerHTML]="pageData?.cmlink$$link_retrieve_user_id?.LINK_TEXT"></a> <span *ngIf="!isCPAY" [innerHTML]="' ' + pageData?.copy$$signon_or?.TEXT + ' '"></span>
                          <a [attr.href]="resetUrl" (click)="resetPassword($event)" class="not-sc-link" [innerHTML]="pageData?.cmlink$$link_reset_password?.LINK_TEXT"></a>
                        </div>

                        <!--  Single FUIP Flow-->
                        <a class="fuipLink-container" href="javascript:void(0)" tabindex="0" *ngIf="isSingleFuipFlow" (click)="redirectToFuip($event)">
                          <div class="link-focus-margins">
                            <a role="link" data-sc-name="forgot_user_id_or_password"  data-module="forgot_user_id_or_password" class="right-arrow-link-fuip" id="fuip">
                              <span [innerHTML]="pageData?.copy$$forget_userid_password?.TEXT"></span>
                            </a>
                          </div>
                          <div class="right-arrow-link-icon-fuip">
                            <span></span>
                          </div>
                        </a>
                      </form>
                  </div>
              </div>
              <div class="row register-card-container border-top">
                  <div class="col-md-12">
                      <div class="text-center">
                          <h2 class="register-card-heading" *ngIf="setupPartner"
                          [innerHTML]="pageData?.copy$$signon_set_up_your_account?.TEXT"></h2>
                          <h2 class="register-card-heading" *ngIf="!setupPartner"
                          [innerHTML]="pageData?.copy$$signon_dillards_setup_your_account?.TEXT"></h2>
                          <button class="secondary-small not-sc-link textBold" (click)="registerYourCard($event)" role="button"
                          [innerHTML]="pageData?.cmlink$$link_get_started?.LINK_TEXT"></button>
                      </div>
                  </div>
              </div>

          </div>
          <div class="col-md-8 col-lg-9">
          <div class="primaryBannerWrapper">
              <primary-banner *ngIf="!adBlockerEnabled"></primary-banner>
              <flex-seo *ngIf="adBlockerEnabled && !isPrimaryContentDiffFromFlexSeo" [pageData]='pageData' [primaryMode]="true" [newCMSContent] = "false"></flex-seo>
              <flex-seo *ngIf="adBlockerEnabled && isPrimaryContentDiffFromFlexSeo" [pageData]='pageData' [primaryMode]="true" [newCMSContent] = "true" ></flex-seo>
          </div>

          <div class="secondaryBannerWrapper" *ngIf="!adBlockerEnabled">
              <secondary-banner></secondary-banner>
          </div>
      </div>

      </section>

      <!-- <flex-banner></flex-banner> -->


